const getDbsForFilters = (all_dbs = [], assigned_dbs = []) => {
  const obj = {};
  all_dbs.forEach((db) => {
    obj[db.route_id] = { ...db, customer_count: 0 };
  });
  assigned_dbs.forEach((adb) => {
    if (obj[adb.route_id]) {
      obj[adb.route_id] = {
        ...obj[adb.route_id],
        customer_count: adb.customer_count,
      };
    } else {
      obj[adb.route_id] = { ...adb, key: adb.route_id };
    }
  });

  const sortedArr = Object.values(obj).sort((a, b) => {
    if (a.route_id === "ALL") return -1;
    if (b.route_id === "ALL") return 1;
    if (a.route_id === "UNASSIGN") return -1;
    if (b.route_id === "UNASSIGN") return 1;
    if (a.route_id === "MISROUTE") return -1;
    if (b.route_id === "MISROUTE") return 1;
    return a.route_id.localeCompare(b.route_id);
  });
  const filteredData = sortedArr.filter(
    (item) =>
      item.customer_count > 0 ||
      item.route_id === "ALL" ||
      item.route_id === "UNASSIGN" ||
      item.route_id === "MISROUTE",
  );
  return filteredData;
};

export default getDbsForFilters;
